import { h } from "preact";
import pluralize from "../../helpers/pluralize";
import SwatchBasketChip from "./swatch-basket-chip";

export default function SwatchDetailsFooter({
  basket,
  strings,
  showPrice,
  swatchCatalogue,
  basketCount,
  canAddMore,
  hasChanges,
  submitting,
  error,
  onRemove,
  onSubmit,
}) {
  // Iterating the catalogue rather than the basket keeps the chips in grid
  // order — a plain object with numeric-string keys would sort them.
  const basketed = [...swatchCatalogue.entries()].filter(
    ([variantId]) => basket[variantId],
  );

  const submitLabel = () => {
    if (submitting) return window.localeStrings.product.adding_to_cart;
    if (!basketCount) return strings.add_to_cart_empty;

    return pluralize(basketCount, strings.add_to_cart);
  };

  const basketTotal = basketed.reduce(
    (total, [variantId, { price }]) =>
      total + parseFloat(price?.amount || 0) * basket[variantId],
    0,
  );

  const currency = basketed.find(([, { price }]) => price)?.[1].price
    .currencyCode;

  const priceLabel =
    showPrice && basketTotal > 0
      ? window.formatMoney(basketTotal, false, currency)
      : null;

  return (
    <div className="swatch-details-drawer__footer">
      <div className="swatch-details-drawer__footer-summary">
        <div className="swatch-details-drawer__footer-summary-row">
          <span className="swatch-details-drawer__footer-count">
            {pluralize(basketCount, strings.selected_count)}
          </span>
          {!basketCount && (
            <span className="swatch-details-drawer__footer-hint">
              {strings.select_prompt}
            </span>
          )}
        </div>
        {!canAddMore && (
          <p className="swatch-details-drawer__footer-limit">
            {strings.limit_reached}
          </p>
        )}
      </div>
      {basketed.length > 0 && (
        <div className="swatch-details-drawer__basket">
          {basketed.map(([variantId, entry]) => (
            <SwatchBasketChip
              key={variantId}
              entry={entry}
              strings={strings}
              quantity={basket[variantId]}
              onRemove={() => onRemove(variantId)}
            />
          ))}
        </div>
      )}
      <button
        type="button"
        className="button button--black button--full swatch-details-drawer__submit"
        disabled={!hasChanges || submitting}
        onClick={onSubmit}
      >
        {submitLabel()}
        {priceLabel && (
          <span className="swatch-details-drawer__submit-price">
            {priceLabel}
          </span>
        )}
      </button>
      {error && <p className="swatch-details-drawer__footer-error">{error}</p>}
    </div>
  );
}
